import React, { Component } from 'react'
import PropTypes from 'prop-types'
import strings from './legal-texts.json'
import styles from './legal-texts.scss'

class LegalTexts extends Component {
    renderChinese() {
        if (!this.props.locale || this.props.locale !== 'zh') return null

        return (
            <div className={styles.legal_texts}>
                <ul>
                    {strings.zh.reference.map((value, index) => (
                        // eslint-disable-next-line
                        <li key={`legal-text-reference-${index}`}>{value}</li>
                    ))}
                </ul>
                <ul className={styles.zh_health_warning}>
                    {strings.zh.health_warning.map((value, index) => (
                        // eslint-disable-next-line
                        <li key={`legal-text-health-${index}`}>{value}</li>
                    ))}
                </ul>
            </div>
        )
    }

    render() {
        switch (this.props.locale) {
            case 'zh':
                return this.renderChinese()

            default:
                return null
        }
    }
}

LegalTexts.propTypes = {
    locale: PropTypes.string,
}

export default LegalTexts



// WEBPACK FOOTER //
// ./src/components/LegalTexts/legal-texts.js